import "./dist-CQa_ahbE.js";
//#region src/generated/types.gen.ts
var e = {
	BOL: "BOL",
	CSCART: "CSCART",
	LIGHTSPEED: "LIGHTSPEED",
	MAGENTO: "MAGENTO",
	PRESTA: "PRESTA",
	SHOPIFY: "SHOPIFY",
	WOOCOMMERCE: "WOOCOMMERCE"
};
//#endregion
export { e as t };
